import { type HTMLAttributes, type Ref } from 'react';

import { Stack } from '@craft/ui/components/structural';

export const SearchBarListbox = (
  props: { readonly ref?: Ref<HTMLDivElement> } & HTMLAttributes<HTMLDivElement>,
) => <Stack {...props} gap={1} />;
